$('input[name="fullName"]').attr("placeholder", "Např. Jana Nováková");
$('input[name="email"]').attr("placeholder", "jana.novakova@email.cz");
$('textarea[name="message"]').attr("placeholder", "Napište, s čím vám můžeme pomoci...");
$("#formContact .submit-wrapper");
